<template>
    <v-sheet class=" pl-10 ml-0 pr-10 bg-transparent grant-access-page">
        <v-container fluid class="" style="margin-top: 50px;">
            <v-card>
                <v-row align="center">
                    <v-col md="4" cols="4" align="center" justify="center">
                        <v-img alt="Access Lock"
                               class="shrink mr-4"
                               :src="require('../../src/assets/lock-round.jpg')"
                               transition="scale-transition"
                               width="500" />

                    </v-col>
                    <v-col md="8" cols="8">
                        <v-row>
                            <v-col>
                                <!--style="position: absolute;top:25%;left:40%;"-->
                                <div class="text-left container">
                                    <h2 class="py-10 pr-10 mds-font--display-3">You've stumbled on restricted access</h2>
                                    <p class="mds-font--display-1">
                                        Error : 401 Unauthorized User
                                    </p>
                                    <span  class="mds-font--display-1">Sorry, you do not have access to this particular resource. Please contact Administrator</span>
                                </div>
                            </v-col>
                        </v-row>

                    </v-col>
                </v-row>
            </v-card>
        </v-container>
    </v-sheet>
</template>

<script>
    
    import { store } from '../store/store'
    export default {
        name: 'UnauthorizedView',
        store,
        components: {
        },
        /*created() {
            if (this.$store.state.isAuth) {
                this.$router.push("/");
            }
        },*/
        data() {
            return {

            }
        }
    }
</script>
<style scoped>
    /*.abc{
        background-color: red
    }*/
</style>

